// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-paginated-page-template-js": () => import("C:\\Users\\Ulrjch\\Downloads\\Compressed\\gatsby-starter-infinite-scroll-master\\src\\templates\\paginatedPageTemplate.js" /* webpackChunkName: "component---src-templates-paginated-page-template-js" */),
  "component---src-pages-404-js": () => import("C:\\Users\\Ulrjch\\Downloads\\Compressed\\gatsby-starter-infinite-scroll-master\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-view-item-js": () => import("C:\\Users\\Ulrjch\\Downloads\\Compressed\\gatsby-starter-infinite-scroll-master\\src\\pages\\viewItem.js" /* webpackChunkName: "component---src-pages-view-item-js" */)
}

